export default __webpack_public_path__ + "static/ClarityNuvo-Light-19328630e6a1824bd786b7672c57339f.woff2";